import React from 'react';
import { Paper, Typography } from '@material-ui/core';

/** Mes en que se habilitan las secciones que todavía están en construcción. */
const MES_DISPONIBLE = 'diciembre';

const NARANJA = '#f15a29';
const AMARILLO = '#fbb040';
const GRIS = 'rgb(81,81,81)';
const TIERRA = '#8d6e63';

// Animaciones del dibujo (prefijo prox- para no chocar con otras clases). Los giros usan el sistema de
// coordenadas del SVG (transform-box: view-box) para girar la pala desde el hombro.
const estilosAnimacion = `
  .prox-palear {
    transform-box: view-box;
    transform-origin: 130px 96px;
    animation: prox-palear 1.2s ease-in-out infinite;
  }
  .prox-respirar {
    animation: prox-respirar 1.2s ease-in-out infinite;
  }
  .prox-tierra {
    opacity: 0;
    animation: prox-tierra 1.2s ease-out infinite;
  }
  .prox-tierra-2 { animation-delay: 0.08s; }
  .prox-tierra-3 { animation-delay: 0.16s; }
  .prox-tierra-4 { animation-delay: 0.24s; }
  @keyframes prox-palear {
    0%, 100% { transform: rotate(12deg); }
    50% { transform: rotate(-22deg); }
  }
  @keyframes prox-respirar {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-1.5px); }
  }
  @keyframes prox-tierra {
    0%, 45% { opacity: 0; transform: translate(0, 0); }
    55% { opacity: 1; }
    100% { opacity: 0; transform: translate(14px, -34px); }
  }
  @media (prefers-reduced-motion: reduce) {
    .prox-palear, .prox-respirar, .prox-tierra { animation: none; }
    .prox-tierra { opacity: 0; }
  }
`;

/** Obrero cavando con una pala, con un cono y un cartel de obra. */
const TrabajadorSvg = () => (
  <svg
    viewBox="0 0 240 200"
    width={240}
    style={{ maxWidth: '100%', height: 'auto' }}
    role="img"
    aria-label="Trabajador cavando: sección en construcción"
  >
    <style>{estilosAnimacion}</style>

    {/* Suelo */}
    <line x1="10" y1="172" x2="230" y2="172" stroke="#bdbdbd" strokeWidth="3" strokeLinecap="round" />

    {/* Cartel de obra */}
    <line x1="214" y1="118" x2="214" y2="172" stroke={GRIS} strokeWidth="3" />
    <rect x="190" y="100" width="48" height="22" rx="3" fill={AMARILLO} stroke={GRIS} strokeWidth="2" />
    <text x="214" y="115" textAnchor="middle" fontSize="9" fontWeight="bold" fill={GRIS} fontFamily="Arial, sans-serif">
      EN OBRA
    </text>

    {/* Montículo de tierra */}
    <ellipse cx="184" cy="172" rx="28" ry="11" fill={TIERRA} />

    {/* Cono */}
    <path d="M30 170 L44 124 L58 170 Z" fill={NARANJA} />
    <path d="M37.5 147 L50.5 147 L53 155 L35 155 Z" fill="white" />
    <rect x="24" y="168" width="40" height="6" rx="2" fill={NARANJA} />

    {/* Piernas y botas */}
    <rect x="108" y="128" width="10" height="42" rx="3" fill={GRIS} />
    <rect x="122" y="128" width="10" height="42" rx="3" fill={GRIS} />
    <ellipse cx="111" cy="171" rx="9" ry="4" fill="#3e2723" />
    <ellipse cx="129" cy="171" rx="9" ry="4" fill="#3e2723" />

    <g className="prox-respirar">
      {/* Chaleco con bandas reflectivas */}
      <rect x="104" y="88" width="32" height="44" rx="8" fill={NARANJA} />
      <rect x="104" y="102" width="32" height="4" fill="#eeeeee" />
      <rect x="104" y="116" width="32" height="4" fill="#eeeeee" />

      {/* Cabeza y casco */}
      <circle cx="120" cy="74" r="12" fill="#f2c9a0" />
      <circle cx="116" cy="74" r="1.6" fill={GRIS} />
      <circle cx="124" cy="74" r="1.6" fill={GRIS} />
      <path d="M115 79 Q120 83 125 79" stroke={GRIS} strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <path d="M106 70 A14 13 0 0 1 134 70 Z" fill={AMARILLO} />
      <rect x="102" y="68" width="36" height="5" rx="2" fill={AMARILLO} />

      {/* Brazos y pala: giran desde el hombro */}
      <g className="prox-palear">
        <line x1="128" y1="92" x2="178" y2="146" stroke="#a1887f" strokeWidth="4" strokeLinecap="round" />
        <path d="M172 140 L190 150 L183 166 L166 156 Z" fill="#9e9e9e" stroke={GRIS} strokeWidth="1.5" />
        <line x1="110" y1="96" x2="146" y2="112" stroke={NARANJA} strokeWidth="7" strokeLinecap="round" />
        <line x1="132" y1="96" x2="160" y2="126" stroke={NARANJA} strokeWidth="7" strokeLinecap="round" />
        <circle cx="147" cy="112" r="4" fill="#f2c9a0" />
        <circle cx="161" cy="127" r="4" fill="#f2c9a0" />
      </g>
    </g>

    {/* Tierra que salta de la pala */}
    <circle className="prox-tierra" cx="180" cy="156" r="3" fill={TIERRA} />
    <circle className="prox-tierra prox-tierra-2" cx="186" cy="152" r="2.5" fill={TIERRA} />
    <circle className="prox-tierra prox-tierra-3" cx="176" cy="150" r="2" fill={TIERRA} />
    <circle className="prox-tierra prox-tierra-4" cx="190" cy="158" r="2" fill={TIERRA} />
  </svg>
);

/** Página de una sección que todavía no está disponible (Presupuestos, Cotizaciones, Órdenes de compra). */
const Proximamente = ({ titulo }) => {
  sessionStorage.setItem('seccionNombre', titulo);

  return (
    <Paper
      elevation={0}
      style={{
        padding: '40px 20px',
        textAlign: 'center',
        backgroundColor: 'white',
        border: '1px solid #d9d9d9',
        borderRadius: '3px',
        boxShadow: '0px 3px 6px #00000029',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <TrabajadorSvg />
      <Typography variant="h5" style={{ fontWeight: 'bold', marginTop: '16px' }}>
        ¡Estamos construyendo {titulo}!
      </Typography>
      <Typography variant="subtitle1" style={{ marginTop: '8px' }}>
        Disponible a partir de{' '}
        <span
          style={{
            display: 'inline-block',
            padding: '2px 12px',
            borderRadius: '12px',
            backgroundColor: NARANJA,
            color: 'white',
            fontWeight: 'bold',
            textTransform: 'capitalize'
          }}
        >
          {MES_DISPONIBLE}
        </span>
      </Typography>
      <Typography variant="body2" style={{ color: 'gray', marginTop: '12px', maxWidth: '420px' }}>
        Nuestro equipo está poniendo las últimas piedras. Mientras tanto, podés seguir usando el resto de Analytics.
      </Typography>
    </Paper>
  );
};

export default Proximamente;
